module.exports = __webpack_public_path__ + "static/media/show-02.cbac4c85.svg";